import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { CustomerCrmService, RmsMessageService } from '@services';

@Component({
  selector: 'app-customer-audit',
  imports: [RmsModule],
  templateUrl: './customer-audit.component.html',
  styleUrl: './customer-audit.component.scss'
})
export class CustomerAuditComponent implements OnChanges {
  @Input() companyId!: number;
  AuditEntries: any[] = [];

  Columns: Column[] = [
    { label: 'Date', key: 'DateDisplay', width: 16 },
    { label: 'User', key: 'UserDisplay', width: 14 },
    { label: 'Area', key: 'Area', width: 14, SearchType: 'select' },
    { label: 'Action', key: 'ActionType', width: 12, SearchType: 'select' },
    { label: 'Details', key: 'Details', width: 44 },
  ];

  constructor(
    private crm: CustomerCrmService,
    private message: RmsMessageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companyId']) {
      this.load();
    }
  }

  load() {
    if (!this.companyId) return;
    this.crm.getAuditHistory(this.companyId).subscribe({
      next: (entries) => {
        this.AuditEntries = (entries || []).map((e: any) => ({
          ...e,
          DateDisplay: e.ChangedDate ? new Date(e.ChangedDate).toLocaleString() : '—',
          // ChangedBy is null for automated/system-driven changes, and blank for real
          // users until auth is wired into this app (dbo.user has no rows yet).
          UserDisplay: e.ChangedBy == null ? 'System' : (e.ChangedByName || '—')
        }));
      },
      error: (err) => this.message.error('Failed to load audit history: ' + this.errorText(err))
    });
  }

  private errorText(err: any): string {
    return err?.error?.error?.message || err?.message || 'Unknown error';
  }
}
